import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'form-field-checked',
    templateUrl: './form-field-checked.component.html',
    standalone: false
})
export class FormFieldCheckedComponent implements OnInit {

  @Input() form: FormGroup;
  @Input('groupName') formGroupName: string;
  @Input('controlName') formControlName: string;
  @Input() label: string;

  @Input() value: boolean = false;
  @Output('value') output_value = new EventEmitter<boolean>();


  constructor() { }

  ngOnInit() {
    this.emit();
  }

  emit() {
    this.output_value.emit(this.value)
  }



}
